import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { selectedResourcesAccountsMetadataSelector } from "@/store/resources-grid/selectors/grid/selection/account/selectedResourcesAccountsMetadataSelector";
import { ProviderAccessType } from "@/services/cloudchipr.api";

export const selectedResourcesAccountAccessTypesSelector =
  createDraftSafeSelector(
    [selectedResourcesAccountsMetadataSelector],
    (accountsMetadata): ProviderAccessType | undefined => {
      let accessType: ProviderAccessType = "read";

      const hasReadWrite = accountsMetadata?.some(
        (item) => item.accessType === "read_write",
      );

      if (hasReadWrite) {
        accessType = "read_write";
      }

      return accessType;
    },
  );
